package com.xtream.ui.ui.util.extensions

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.LinearOutSlowInEasing
import androidx.compose.animation.core.tween
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableLongStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import kotlin.time.Clock

fun Modifier.focusAlphaFade(
    itemIndex: Int,
    lastFocusedIndex: () -> Int,
    previousAlpha: Float = 0.3f,
    focusedAlpha: Float = 1f,
    futureAlpha: Float = 1f
): Modifier = this.composed {

    val initialAlpha = remember {
        val currentFocus = lastFocusedIndex()
        when {
            itemIndex == currentFocus -> focusedAlpha
            itemIndex + 1 == currentFocus -> previousAlpha
            else -> futureAlpha
        }
    }

    val animatedAlpha = remember { Animatable(initialAlpha) }

    LaunchedEffect(lastFocusedIndex()) {
        val currentFocus = lastFocusedIndex()
        val target = when {
            itemIndex == currentFocus -> focusedAlpha
            itemIndex + 1 == currentFocus -> previousAlpha
            else -> futureAlpha
        }
        animatedAlpha.animateTo(
            targetValue = target,
            animationSpec = tween(durationMillis = 300, easing = LinearOutSlowInEasing)
        )
    }

    this.graphicsLayer {
        this.alpha = animatedAlpha.value
    }
}
fun Modifier.throttleAllKeys(
    thresholdMs: Long = 150L
): Modifier = this.composed {
    // Tracks the last time ANY key was allowed to pass
    var lastKeyEventTime by remember { mutableLongStateOf(0L) }

    this.onPreviewKeyEvent { keyEvent ->
        // We only care about 'repeat' events (when a key is held down)
        // or very rapid individual 'Down' presses.
        val isRepeat = false//TODO keyEvent.nativeKeyEvent.repeatCount > 0
        val isKeyDown = keyEvent.type == KeyEventType.KeyDown

        if (isKeyDown) {
            val currentTime = Clock.System.now().toEpochMilliseconds()
            val timeSinceLastEvent = currentTime - lastKeyEventTime

            if (isRepeat && timeSinceLastEvent < thresholdMs) {
                // 🛑 BLOCK: This repeat is happening too fast
                true
            } else {
                // ✅ ALLOW: Update the timestamp and let the event through
                lastKeyEventTime = currentTime
                false
            }
        } else {
            // Always allow KeyUp events so the system knows the button was released
            false
        }
    }
}